import { Component } from 'opus-angular-seed-core';

@Component({
    template: `
    <forms-questions-filter state="'allQuestions'" list="vm.list" filter="vm.filter" default-query="vm.defaultQuery"></forms-questions-filter>
    <list-factory-empty list="vm.list" show-add-message="true"></list-factory-empty>
    <div class="well" ng-if="vm.list.items.length && !vm.loading">
        <table class="data01" datatable dt-options="vm.DATATABLES">
            <thead>
            <tr>
                <th ng-class="vm.list.getSortClass('name')"><a ng-click="vm.list.sortBy('name')">{{ 'questions.Name' | translate }}</a></th>
                <th ng-class="vm.list.getSortClass('externalId')"><a ng-click="vm.list.sortBy('externalId')">{{ 'questions.ID' | translate }}</a></th>
                <th ng-class="vm.list.getSortClass('pool')"><a ng-click="vm.list.sortBy('pool')">{{ 'questions.Pool' | translate }}</a></th>
                <th ng-class="vm.list.getSortClass('category')"><a ng-click="vm.list.sortBy('category')">{{ 'questions.Category' | translate }}</a></th>
                <th ng-class="vm.list.getSortClass('displayName')"><a ng-click="vm.list.sortBy('displayName')">{{ 'questions.Author' | translate }}</a></th>
                <th ng-class="vm.list.getSortClass('createdAt')"><a ng-click="vm.list.sortBy('createdAt')">{{ 'questions.Created' | translate }}</a></th>
                <th>&nbsp;</th>
            </tr>
            </thead>
            <tbody>
                <tr ng-repeat="question in vm.list.items">
                    <td><a ui-sref="authorized.forms.questions.all.question(vm.QuestionRouteService.getParams(question, vm.filter, vm.list))">{{ question.nameWithoutHtml }}</a></td>
                    <td>{{ question.externalId }}</td>
                    <td>{{ question.pool ? question.pool.name : '' }}</td>
                    <td>{{ question.category ? question.category.name : '' }}</td>
                    <td>{{ question.author ? question.author.displayName : '' }}</td>
                    <td>{{ question.createdAt ? (question.createdAt * 1000 | date : 'dd.MM.yyyy') : '' }}</td>
                    <td class="actions">
                        <a ng-if="vm.QuestionService.canManageQuestionRelatedData()" ng-click="vm.delete(question)" class="btn delete">{{ 'questions.Delete' | translate }}</a>
                    </td>
                </tr>
            </tbody>
        </table>
        <pagination list="vm.list"></pagination>
    </div>
    `
})
export default class {
    constructor ($scope, $translate, $stateParams, lodash, toastr, DATATABLES, ListFactory, QuestionResource, ModalService, QuestionRouteService, QuestionService) {
        this.$translate = $translate;
        this.toastr = toastr;
        this.DATATABLES = DATATABLES;
        this.ModalService = ModalService;
        this.QuestionRouteService = QuestionRouteService;
        this.QuestionService = QuestionService;

        this.defaultQuery = { expand: 'pool,category,author,questionI18ns,activeI18n,formQuestions' };

        this.filter = lodash.assign({}, this.defaultQuery, $stateParams);
        this.list = ListFactory.createWithPagination(QuestionResource.query.bind(QuestionResource));

        this.list.pagination.currentPage = $stateParams.page ? $stateParams.page : 1;
        this.list.sort = $stateParams.sort ? $stateParams.sort : null;
        this.list.fetch(this.filter);

        $scope.$on('questionIsAdded', () => {
            this.list.fetch(this.filter);
        });
    }

    delete (question) {
        this.QuestionService.delete(question).then(() => {
            this.list.fetch(this.filter);
        }).catch(() => {
            this.list.fetch(this.filter);
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/questions/all/list/index.js